import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';

import Home from './Home/Home/Home';
import About from './pages/About/About';
import Footer from './pages/Footer/Footer';
import Project from './pages/Projects/Project';


function App() {
  
  return (
    <div >
     <Home></Home>
      <About></About>
      <Project></Project>
      <Footer></Footer>
    </div>
  );
}


export default App;
